import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { types } from '@/modules/sklad/ndObjednavka/ndObjednavkaZakazka/store/types';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter: {
		ZakazkaId: null as number | null,
	},
	tableSetting: {},
	localState: {
		ZakazkaIdText: null as string | null,
	},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[types.mutations.ND_OBJEDNAVKA_ZAKAZKA_ZAKAZKA_MAPPER](state, { data }) {
			state.filter.ZakazkaId = data.nr;
			state.localState.ZakazkaIdText = data.text;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
